<template>
  <block>
    <div class="box" v-if="[0, 10].includes(userMemberInfo.level) && (showSeniorBtn === 2 || showBasicBtn === 2) && (seniorPriceInfo.price || basicPriceInfo.price) ">
      <buy-btn :openChat="openChat" v-if="showBasicBtn === 2" :generateOrder="generateOrder" :activeTab="activeTab" v-show="activeTab === 20"
        :priceInfo="basicPriceInfo"></buy-btn>
      <buy-btn :openChat="openChat" v-if="showSeniorBtn === 2" :generateOrder="generateOrder" :activeTab="activeTab" v-show="activeTab === 30"
        :priceInfo="seniorPriceInfo"></buy-btn>
    </div>
    <div class="box" v-if="userMemberInfo.level === 20 && showSeniorBtn === 2 && seniorPriceInfo.price">
      <buy-btn :openChat="openChat" :activeTab="activeTab" :isUpdate="true" :priceInfo="seniorPriceInfo"></buy-btn>
    </div>
  </block>
</template>

<script>
import BuyBtn from './BuyBtn.vue';

export default {
  components: {
    BuyBtn,
  },
  data() {
    return {
      basicPriceInfo: {},
      seniorPriceInfo: {},
    };
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    activeTab: {
      type: Number,
      value: 20,
    },
    showSeniorBtn: {
      type: Number,
      value: 0,
    },
    showBasicBtn: {
      type: Number,
      value: 0,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
    memberLevelInfo: {
      type: Object,
      default: () => ({
        10: {
          packageId: null, // 套餐ID
          products: null, // 套餐内产品
          priceInfo: {}, // 相关价格
        }, // 试用会员
        20: {
          packageId: null,
          products: null,
          priceInfo: {},
        }, // 普通会员
        30: {
          packageId: null,
          products: null,
          priceInfo: {},
        }, // 高级会员
      }),
    },
    generateOrder: {
      type: Function,
      default: () => { },
    },
    openChat: {
      type: Function,
      default: () => { },
    },
  },
  watch: {
    // memberLevelInfo: {
    //   handler(value) {
    //     console.log('11111', value[20].priceInfo.price);
    //   },
    //   deep: true,
    // },
    // eslint-disable-next-line func-names
    'memberLevelInfo.20.priceInfo': function (value) {
      if (value) {
        this.basicPriceInfo = value;
      }
    },
    // eslint-disable-next-line func-names
    'memberLevelInfo.30.priceInfo': function (value) {
      if (value) {
        this.seniorPriceInfo = value;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  position: fixed;
  bottom: 0;
  z-index: 101;
  width: 750px;
  height: 180px;
}
</style>
